import { useTranslation } from 'react-i18next'
import { memo } from 'react'
import { useTheme } from 'styled-components'

import {
  Section,
  Header,
  Icons,
  Title,
  Content,
  GameCardsList
} from './Styles'

import GameCard from 'components/GameCard'
import ActionLine from 'components/ActionLine'
import Buttons from 'components/Buttons'
import Container from 'components/Container'

// icons
import GamePadIcon from 'components/Icon/default/GamePad'
import PackmanIcon from 'components/Icon/default/Packman'
import PotionIcon from 'components/Icon/default/Potion'

function ChoseGamePage() {

  const theme = useTheme()
  const { t, i18n } = useTranslation()

  return (
    <Container>
      <Section>
        <Header>
          <Icons>
            <GamePadIcon color={theme.colors.pink100} />
            <PackmanIcon color={theme.colors.pink100} />
            <PotionIcon color={theme.colors.pink100} />
          </Icons>
          <Title>{t('application.selectPage.chooseGame')}</Title>
        </Header>
        <Content>

          <GameCardsList>
            <GameCard
              game="valorant"
            />
            <GameCard
              game="csgo"
            />
            <GameCard
              game="fortnite"
            />
            <GameCard
              game="apex"
              soon
            />
            <GameCard
              game="warzone"
              soon
            />
            <GameCard
              game="lol"
              soon
            />
            <GameCard
              game="dota2"
              soon
            />
          </GameCardsList>

          <ActionLine
            icon={<GamePadIcon />}
            title={t('application.selectPage.actionLine.title')}
            description={t('application.selectPage.actionLine.description')}
            actionFirst={<Buttons variable='solid' height='big' leftIcon='check'>{t('application.selectPage.actionLine.buttons.main')}</Buttons>}
            actionSecond={<Buttons variable='outline' height='big'>{t('application.selectPage.actionLine.buttons.primary')}</Buttons>}
          />

        </Content>

      </Section>
    </Container>
  )

}


export default memo(ChoseGamePage)